import React, { useEffect, useState, useRef, useCallback } from "react";
import { FaSearch } from "react-icons/fa";

const CustomSelectBox = ({
  item,
  index,
  dropdownOptions = [],
  handleDropdownChange,
  selectedOptions: initialSelectedOptions = [],
}) => {
  // { viztaArea: ['Select an option'] }
  // // console.log(item);
  const [searchTerm, setSearchTerm] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState(
    new Set(initialSelectedOptions)
  );
  // console.log(isOpen);

  const filteredOptions = dropdownOptions.filter((option) =>
    option.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const dropdownRef = useRef(null);

  // Update the selected options when the component mounts or the props change
  useEffect(() => {
    if (item?.initialSelectedOptions) {
      setSelectedOptions(new Set(item.initialSelectedOptions));
    }
  }, [item]);

  useEffect(() => {
    handleDropdownChange(item, Array.from(selectedOptions), index);
  }, [selectedOptions]);

  const handleOptionClick = useCallback((option) => {
    setSelectedOptions((prevSelected) => {
      const newSelected = new Set(prevSelected);
      newSelected.has(option)
        ? newSelected.delete(option)
        : newSelected.add(option);
      return newSelected;
    });
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div
      className="w-full flex flex-col items-start justify-center"
      ref={dropdownRef}
    >
      <div
        onClick={() => setIsOpen(!isOpen)}
        className="cursor-pointer outline-none truncate"
        aria-expanded={isOpen}
        aria-haspopup="true"
        role="button"
      >
        {selectedOptions.size > 1
          ? Array.from(selectedOptions).join(", ").slice(0, 20) +
            (Array.from(selectedOptions).join(", ").length > 20 ? "..." : "")
          : item?.viztaArea?.[0] || "Select an option"}
      </div>
      {isOpen && (
        <section className="absolute z-50 bg-white w-52 rounded shadow-lg">
          {/* Search Bar */}
          <div className="flex items-center p-[2px] relative">
            <FaSearch className="absolute left-3 text-gray-400" />
            <input
              type="text"
              placeholder="Search..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full pl-8 border border-gray-200 rounded focus:outline-none focus:ring-0"
            />
          </div>

          {/* Dropdown Options */}
          <div className="mt-1 max-h-48 overflow-y-auto translate-y-0">
            {filteredOptions.map((option) => (
              <button
                key={option}
                onClick={() => handleOptionClick(option)}
                className={`flex items-center w-full p-[2px] hover:bg-gray-200 truncate`}
              >
                <input
                  type="checkbox"
                  checked={selectedOptions.has(option)}
                  readOnly
                  className="mr-[6px] checkbox-input"
                />
                {option}
              </button>
            ))}
          </div>
        </section>
      )}
    </div>
  );
};

export default CustomSelectBox;
